export const tutorSchedulesLoading =  ({store})  => store.tutorScheduleReducer.loading;

export const tutorSchedulesError =  ({store})  => store.tutorScheduleReducer.error;

export const tutorSchedulesData =  ({store})  => store.tutorScheduleReducer.data;